import {create} from 'zustand';
import { persist, devtools} from 'zustand/middleware';
import { Profile } from '../../services/userService';

type UserActionProps = {
}

type Customer = {
    customerId: string,
    issuer: string,
    name: string,
    cpfCnpj: string
}

type LoginData = {
    customers: Customer[],
    profile?: Profile,
    id: string,
    name: string,
    email: string,
    country: string
}

type UserStoreProps = {
    loginData: LoginData,    
    darkMode: boolean,
    lng: string,
    selectedCustomer: Customer,
    changeDarkMode: (darkMode: boolean) => void;
    changeLng: (lng: string) => void;
    changeLoginData: (data: LoginData) =>  void,
    changeSelectedCustomer: (customer: Customer) =>  void,
}

export const useUserStore = create<UserStoreProps, [['zustand/devtools', never], ['zustand/persist', never]]>
(
    devtools(
        persist(
            (set) => ({
                loginData: {
                    id: '',
                    customers: [],
                    name: '',
                    profile: Profile.Adm,
                    email: '',
                    country: ''
                },
                darkMode: false,
                lng: 'pt',      
                selectedCustomer: {
                    cpfCnpj: '',
                    customerId: '',
                    issuer: '',
                    name: '',
                },          
                changeDarkMode: (darkMode: boolean) => set(() => ({
                    darkMode: darkMode
                })),
                changeLng: (lng: string) => set(() => ({
                    lng: lng
                })),
                changeLoginData: (data: LoginData) => set(() => ({
                    loginData: data
                })),
                changeSelectedCustomer: (customer: Customer) => set(() => ({
                    selectedCustomer: customer
                })),
            }),
            {
                name: 'user-storage'
            }
        )
    )
);